const pointOfSales = [
  {
    title: "NOMBRE DES PONTS DE VENTE DE L'ETS ROSE",
    sales_points: [
      {
        number: 1,
        location: "Bujumbura Mairie",
        sales_type: "INDIRECT",
        province: "Bujumbura",
        commune: "Ntahangwa",
        quarter_hill: "Mutakura",
        sub_hill: null,
        contact_person: "Manirambona Jeanine",
        contact: "79963664"
      },
      {
        number: 2,
        location: "Bubanza",
        sales_type: "INDIRECT",
        province: "Bubanza",
        commune: "Muzinda",
        quarter_hill: "Centre Muzinda",
        sub_hill: null,
        contact_person: "Ndayishimiye Léonard",
        contact: "68127596"
      },
      {
        number: 3,
        location: "Gitega",
        sales_type: "INDIRECT",
        province: "Gitega",
        commune: "Gitega",
        quarter_hill: "Mushasha",
        sub_hill: null,
        contact_person: "Kanyirure Joselyne",
        contact: "69036349"
      },
      {
        number: 4,
        location: "Kayanza",
        sales_type: "INDIRECT",
        province: "Kayanza",
        commune: "Matongo",
        quarter_hill: "Marché Matongo",
        sub_hill: null,
        contact_person: "Anitha",
        contact: "61392791"
      },
      {
        number: 5,
        location: "Kirundo",
        sales_type: "INDIRECT",
        province: "Kirundo",
        commune: "Kirundo",
        quarter_hill: "Nyange Bushaza",
        sub_hill: null,
        contact_person: "Melance",
        contact: "68262723"
      },
      {
        number: 6,
        location: "Ngozi",
        sales_type: "INDIRECT",
        province: "Ngozi",
        commune: "Ngozi",
        quarter_hill: "Kinyami I",
        sub_hill: "Face de la Mosqué",
        contact_person: "Nahimana Chanceline",
        contact: "69089686"
      },
      {
        number: 7,
        location: "Muyinga",
        sales_type: "INDIRECT",
        province: "Muyinga",
        commune: "Gasorwe",
        quarter_hill: "Gasuru",
        sub_hill: null,
        contact_person: "Rirenzumunwa Elias",
        contact: "61140075"
      },
      {
        number: 8,
        location: "Kirundo",
        sales_type: "INDIRECT",
        province: "Kirundo",
        commune: "Kirundo",
        quarter_hill: "UCCODE Kirundo",
        sub_hill: null,
        contact_person: "Rurakengereza Louis",
        contact: "68272335"
      },
      {
        number: 9,
        location: "Bujumbura",
        sales_type: "INDIRECT",
        province: "Bujumbura",
        commune: "Mutimbuzi",
        quarter_hill: "Rubirizi",
        sub_hill: "Tenga",
        contact_person: "Iddy Bujumbura",
        contact: "79955486"
      },
      {
        number: 10,
        location: "Kirundo",
        sales_type: "DIRECT",
        province: "Kirundo",
        commune: "Kirundo",
        quarter_hill: "En face de la BCB",
        sub_hill: "En face de la BCB",
        contact_person: "Buntu Blessing",
        contact: "66074022"
      },
      {
        number: 11,
        location: "Muyinga",
        sales_type: "INDIRECT",
        province: "Muyinga",
        commune: "Muyinga",
        quarter_hill: "UCCODE Muyinga",
        sub_hill: null,
        contact_person: "Ndabaneze Laurent",
        contact: "69885413"
      },
      {
        number: 12,
        location: "Bujumbura",
        sales_type: "INDIRECT",
        province: "Bujumbura",
        commune: "Muha",
        quarter_hill: "Kanyosha",
        sub_hill: "Gisyo",
        contact_person: "Iddy Bujumbura",
        contact: "65949919"
      }
    ]
  }
];

export default pointOfSales;
